import { render, staticRenderFns } from "./DeviceSharesView.vue?vue&type=template&id=70d1031e&scoped=true"
import script from "./DeviceSharesView.vue?vue&type=script&lang=ts"
export * from "./DeviceSharesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1031e",
  null
  
)

export default component.exports